import { ChangeDetectionStrategy, Component, OnInit, signal, WritableSignal } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { ActivatedRoute, ActivationEnd, Event, Router } from '@angular/router';
import { DateTime } from 'luxon';
import { DialogService } from 'primeng/dynamicdialog';
import { finalize } from 'rxjs';
import { FormFieldService } from 'src/app/api/form-field.service';
import { IncidentsService, IncidentTypes } from 'src/app/api/incidents.service';
import { FormProgressService } from 'src/app/storage/form-progress.service';
import { FormField } from '../forms/formDefinition';
import { IncidentModalService } from '../modals/incident-modal.service';
import { MessageBoxResults } from '../modals/message-box/message-box.component';

@Component({
  selector: 'app-create-witness-report',
  templateUrl: './create-witness-report.component.html',
  styleUrls: ['./create-witness-report.component.scss'],
  providers: [DialogService],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CreateWitnessReportComponent implements OnInit {


  constructor(
    private fb: UntypedFormBuilder,
    private incidentService: IncidentsService,
    private router: Router,
    private formFieldService: FormFieldService,
    private route: ActivatedRoute,
    private formProgressService: FormProgressService,
    private incidentModalService: IncidentModalService,
    private dialogService: DialogService
  ) { }


  incidentReportType: WritableSignal<IncidentTypes> = signal(IncidentTypes.Unknown);

  witnessReportFields: WritableSignal<FormField[]> = signal([])

  witnessReportFormData: WritableSignal<any> = signal({});

  submitError = signal("");
  showErrDetails = signal(false);
  errorCopied = signal(false);

  submittingReport = signal(false);

  ngOnInit(): void {

    this.route.data.subscribe(data => {
      this.incidentReportType.set(data['incidentType']);

      this.formFieldService.getIncidentReportFields(this.incidentReportType()).subscribe(fields => {
        this.witnessReportFields.set(fields);
      });
    })


    this.formProgressService.getFormProgress(this.getFormKey()).subscribe(progress => {
      if (progress) {
        const progressDate = DateTime.fromJSDate(progress.lastUpdated);
        this.incidentModalService.showMessageBox(
          this.dialogService,
          "Continue Progress?",
          "You have progress from " + progressDate.toFormat("MM/dd/yyyy tt") + ". Would you like to continue where you left off?",
          { cancelButtonText: "Start Over", confirmButtonText: "Continue" })
          .onClose.subscribe(
            (result: MessageBoxResults) => {
              if (result === MessageBoxResults.Confirmed) {
                this.witnessReportFormData.set(progress.formValue);
              }
            }
          )

      }


    })


  }

  createReport(formData: any) {
    this.submitError.set("");
    this.showErrDetails.set(false);
    this.errorCopied.set(false);
    this.submittingReport.set(true);

    this.incidentService.createIncidentReport(formData, this.incidentReportType()).pipe(finalize(() => {
      this.submittingReport.set(false);
    })).subscribe({
      next: () => {
        this.formProgressService.clearFormProgress(this.getFormKey()).subscribe(() => {
          this.router.navigate(['/']);
        })
      },
      error: (err) => {
        this.submitError.set( JSON.stringify(err, undefined, 2));
        console.error(err);
      }
    });
  }

  showErrorDetails() {
    this.showErrDetails.set(true);
  }

  onErrorCopied() {
    this.errorCopied.set(true)
  }

  getFormKey() {
    return "IncidentReportType" + this.incidentReportType()
  }

}
